module.exports = __webpack_public_path__ + "static/media/logo.7782b976.png";